import {
    TOGGLE_SELECTED, SET_READY, SHOW_ERROR, RESET_ERROR
} from 'constants/actionTypes/paypal';
import Actions from 'Actions';
import localeUtils from 'utils/LanguageLocale';
import PayPalEN from 'constants/locales/PayPal_en_US';
import PayPalFR from 'constants/locales/PayPal_fr_CA';

export const ERROR_TYPES = {
    ERROR: 'error',
    CANCELLED: 'cancelled'
};

export function toggleSelect(isSelected) {
    return {
        type: TOGGLE_SELECTED,
        isSelected
    };
}

export function setReady(isReady) {
    return {
        type: SET_READY,
        isReady
    };
}

export function showError(errorMessage) {
    return {
        type: SHOW_ERROR,
        error: {
            errorMessage
        }
    };
}

export function resetError() {
    return {
        type: RESET_ERROR
    };
}

/**
 * Show error modal for PayPal payment cancellation or errors
 * Follows Venmo pattern (VenmoActions.js:25-33)
 * @param {object} options - Error details
 * @param {string} options.errorType - Type of error: ERROR_TYPES.CANCELLED or ERROR_TYPES.ERROR
 * @returns {object} InfoModal action
 */
export function showModalError({ errorType = ERROR_TYPES.ERROR } = {}) {
    const getText = localeUtils.getLocalisedDataFromResource(PayPalEN, PayPalFR);
    const isCancelled = errorType === ERROR_TYPES.CANCELLED;
    const title = isCancelled ? getText('paymentCancelledTitle') : getText('paymentErrorTitle');
    const message = isCancelled ? getText('paymentCancelledMessage') : getText('paymentErrorMessage');

    return Actions.showInfoModal({
        isOpen: true,
        isHtml: false,
        title,
        message,
        buttonText: getText('okButton')
    });
}
